import React, { useState } from 'react'
import Login from '../../../Components/Login/Login'
import Signup from '../../../Components/Signup/Signup'
import style from './index.module.css'
import MobileSignup from '../../../Components/MobileSighnup/MobileSighnup'

const Registration_login = () => {

  const [signup, setSignup] = useState(false)

  return (
    <div className={style.Registration_wrapper}>
      {signup ? <MobileSignup setLogin={setSignup} /> : <Login setLogin={setSignup} />}
      {/* <MobileSignup /> */}
    </div>
  )
}

export default Registration_login